import { TitleCasePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-auto-distribution-modal',
  templateUrl: './auto-distribution-modal.component.html',
  styleUrls: ['./auto-distribution-modal.component.css']
})
export class AutoDistributionModalComponent implements OnInit, AfterViewInit {
  preCompanies: any = {};
  companies: any = [];
  drivers: any = [];
  selectedCompanies: any = [];
  selectedDrivers: any = [];
  selectedCompany: any = null;
  selectedDriver: any = null;
  status: string = '';
  @Input() trips: any;
  @Input() preServiceAreas: any;
  @Output() closeModal = new EventEmitter<any>();
  preSpacetypes: any = {};
  search: any;
  search2: any
  fareEstimation: any;
  levelofservices: any;
  preLevelOfService: any = {};
  preAppointmentType: any = {};
  allSelected = false; // new flag
  tab: any = 'company'

  showMap = false;
  @ViewChild(GoogleMap) map!: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  infoWindowRef: google.maps.InfoWindow | null = null;
  center: google.maps.LatLngLiteral = { lat: 37.7749, lng: -122.4194 };
  zoom = 5;
  allMarkers = new google.maps.MVCArray<google.maps.marker.AdvancedMarkerElement>();
  points: any = []
  selectedTrip: any;


  constructor(
    private tripService: TripService,
    private companyService: CompanyService,
    private appointmentService: AppointmentTypeService,
    private configurationService: ConfigurationService,
    private spaceTypeService: SpaceTypeService,
    private memberService: MemberService,
    private router: Router,
    private levelOfService: LosService,
    private credentialService: CredentialService
  ) { }

  ngOnInit(): void {
    this.getSpaceType();
    this.getLevelOfService();
    this.getAllAppointment();
    this.getAllCompanies();
  }

  ngAfterViewInit(): void {
    if (!this.map || !this.map.googleMap) {
      console.warn('Google Map not initialized yet');
      return;
    }
    this.map.googleMap.setOptions({
      mapId: '9fe6e06d06a9024ce7fa85b2',
    });
    setTimeout(() => this.setInitialBounds(), 300);

  }

  getAllCompanies() {
    const queryParams = {
      isActive: true,
      isApproved: true,
      limit: 9999
    };
    this.credentialService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preCompanies = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
        this.companies = data.results.map((company: any) => ({
          ...company,
          isSelected: false
        }));
        this.points = data.results.map((c: any) => {
          const coords = c.address?.coords?.length
            ? { lat: c.address.coords[1], lng: c.address.coords[0] }
            : null;
          return { id: c.id, name: c.name, profileImageURL: c.profileImageURL, email: c.email, coords };
        });
        this.clearMarkers();
        this.addMarkers(this.points);
      }
    });
  }

  getAllDrivers() {
    let queryParams = {
      limit: 9999,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPickerDrivers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.drivers = data.results.filter((item: any) => {
          if (item.company && this.preCompanies[item.company]) {
            const driverCompany = this.preCompanies[item.company]
            if (driverCompany.isActive && driverCompany.isApproved) {
              return item;
            }
          }
        })

        this.points = this.drivers.map((c: any) => {
          const coords = c.address?.coords?.length
            ? { lat: c.address.coords[1], lng: c.address.coords[0] }
            : null;
          return { id: c.id, name: c.firstName + ' ' + c.lastName, profileImageURL: c.profileImageURL, email: c.email, coords };
        });
        this.clearMarkers();
        this.addMarkers(this.points);
      }
    })
  }

  onSelectCompany(company: any) {
    company.isSelected = !company.isSelected;

    if (company.isSelected) {
      this.selectedCompanies.push(company.id);
    } else {
      this.selectedCompanies = this.selectedCompanies.filter((id: any) => id !== company.id);
    }

    // Update allSelected flag based on manual selection
    this.allSelected = this.selectedCompanies.length === this.companies.length;

    this.selectedCompany = company;
  }

  onSelectDriver(driver: any) {
    driver.isSelected = !driver.isSelected;

    if (driver.isSelected) {
      this.selectedDrivers.push(driver.id);
    } else {
      this.selectedDrivers = this.selectedDrivers.filter((id: any) => id !== driver.id);
    }
    this.selectedCompanies = [
      ...new Set(
        this.drivers
          .filter((d: any) => this.selectedDrivers.includes(d.id))
          .map((d: any) => d.company)
      )
    ];

    this.allSelected = this.selectedDrivers.length === this.drivers.length;

    this.selectedDriver = driver;
  }



  removeTrip(index: number) {
    if (index > -1 && index < this.trips.length) {
      this.trips.splice(index, 1);
    }
  }

  getFareEstimation() {
    const payload = {
      trips: this.trips,
      company: this.selectedCompany.id
    };

    this.credentialService.getFareEstimation(payload).subscribe((data: any) => {
      if (data) {
        this.fareEstimation = data;
      }
    })
  }

  getSpaceType() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preSpacetypes = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  getLevelOfService() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.levelOfService.getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.levelofservices = data.results;
          this.preLevelOfService = this.levelofservices.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getAllAppointment() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.appointmentService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.preAppointmentType = data.results.reduce((obj: any, item: any) => ((obj[item.id] = item), obj), {});
      }
    });
  }

  calculateComission(fare: any, offeredFare: any) {
    const commission = fare - offeredFare;
    return commission;
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  distribute() {
    sweetAlert(
      "Alert",
      "Are you sure you want to auto distribute trip",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          pre: this.trips && this.trips.length > 1 ? this.preTripCompany() : [{ company: this.trips[0].company, trip: this.trips[0].id }],
          selectedIds: this.trips && this.trips.length > 1 ? this.trips.map((trip: any) => trip.id) : [this.trips[0].id],
          selectedCompaniesIds: this.selectedCompanies,
          selectedDriversIds: this.selectedDrivers
        };
        this.tripService.autoDistribute(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
          if (data) {
            if (data.statusUpdate)
              this.onCloseModal();
              const {skippedTrips, message} = data.statusUpdate;
              if (skippedTrips && skippedTrips.length) {
                const html = this.getSkippedTripsHtml(skippedTrips, message);
                sweetAlertWithHtml("Alert", "This is a sample message", "alert", "OK", html);
              } else {
                sweetAlert("Alert", data.statusUpdate.message, "alert", "OK");
              }
          }
        });

      }
    });
  }

  preTripCompany() {
    const previousAssignedCompanies = this.trips
      .filter((trip: any) => trip.company)
      .map((trip: any) => ({
        company: trip.company,
        trip: trip.id
      }));
    return previousAssignedCompanies;
  }

  selectAll() {
    this.allSelected = !this.allSelected;
    if (this.tab === 'company') {
      this.companies.forEach((company: any) => {
        company.isSelected = this.allSelected;
      });

      if (this.allSelected) {
        this.selectedCompanies = this.companies.map((company: any) => company.id);
      } else {
        this.selectedCompanies = [];
      }
    } else {
      this.drivers.forEach((driver: any) => {
        driver.isSelected = this.allSelected;
      });

      if (this.allSelected) {
        this.selectedDrivers = this.drivers.map((driver: any) => driver.id);
        this.selectedCompanies = [
          ...new Set(
            this.drivers
              .filter((d: any) => this.selectedDrivers.includes(d.id))
              .map((d: any) => d.company)
          )
        ];
      } else {
        this.selectedDrivers = [];
      }
    }

  }

  setTab(tab: string) {
    this.tab = tab;
    if (tab === 'company') {
      this.getAllCompanies();
      this.drivers = [];
    } else {
      this.getAllDrivers();
      this.companies = [];
    }
    this.fareEstimation = null;
  }


  onShowMap() {
    this.showMap = !this.showMap
    setTimeout(() => this.setInitialBounds(), 300);
  }

  openInfo(marker: MapMarker, trip: any) {
    this.selectedTrip = trip;
    this.infoWindow.open(marker);
  }


  setInitialBounds() {
    if (!this.map || !this.map.googleMap) return;
    const bounds = new google.maps.LatLngBounds();

    (this.trips || []).forEach((trip: any) => {
      const pickup = trip.pickup?.address?.coords;
      const dropoff = trip.dropoff?.address?.coords;
      if (pickup?.length === 2) bounds.extend({ lat: pickup[1], lng: pickup[0] });
      if (dropoff?.length === 2) bounds.extend({ lat: dropoff[1], lng: dropoff[0] });
    });

    (this.points || []).forEach((p: any) => {
      if (p.coords) bounds.extend(p.coords);
    });

    if (!bounds.isEmpty()) this.map.googleMap.fitBounds(bounds);
  }


  clearMarkers() {
    this.allMarkers.forEach(marker => (marker.map = null));
    this.allMarkers.clear();
  }

  addMarkers(points: any[]) {
    if (!points?.length) return;
    points.forEach((point: any) => {
      if (!point.coords) return;

      const markerElement = document.createElement('div');
      markerElement.innerHTML = this.getMarkerContent(point);

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map.googleMap,
        position: point.coords,
        content: markerElement,
        title: point.name
      });

      this.allMarkers.push(marker);

      const infoWindow = new google.maps.InfoWindow({
        content: this.getInfoWindowContent(point)
      });

      marker.addListener('click', () => {
        if (this.infoWindowRef) this.infoWindowRef.close();
        this.infoWindowRef = infoWindow;
        infoWindow.open({ anchor: marker, map: this.map.googleMap });
      });
    });
  }

  getMarkerContent(entity: any): string {
    const size = entity.company ? 'w-10 h-10' : 'w-12 h-12';
    return `
      <div>
        <div class="${size} rounded-full overflow-hidden border-2 border-gray-300 shadow-md">
          <img src="${entity.profileImageURL || 'assets/images/profileImagePlaceholder.png'}"
               alt="${entity.name}" class="w-full h-full object-cover"/>
        </div>
      </div>`;
  }

  getInfoWindowContent(entity: any): string {
    return `
      <div>
        <p><span class="font-semibold">Name:</span> ${entity.name}</p>
        <p><span class="font-semibold">Email:</span> ${entity.email}</p>
        ${entity.company && this.preCompanies[entity.company]
        ? `<p><span class="font-semibold">Company:</span> ${this.preCompanies[entity.company].name}</p>`
        : ''}
      </div>`;
  }

  getSkippedTripsHtml(skippedTripsIds: any, message: any) {
    const skippedTrips = this.trips.filter((trip: any) => skippedTripsIds.includes(trip.id))
    let html = `<p class="mb-4">${message}</p><div
    class="max-h-[400px] overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                   <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Member
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference ID
                  </th>
                </tr>
              </thead>
              <tbody>`;
    skippedTrips.forEach((trip: any) => {
      html += `
                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                  <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   ${trip?.member?.displayName ? new TitleCasePipe().transform(trip?.member?.displayName) : ''}}
                  </td>
                  <td class="px-3 py-1 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   ${trip.reference}${trip.suffix ? '-' + trip.suffix : ''}
                  </td>
                </tr>
                `;
    });
    html += `
              </tbody>
            </table>
            </div>
            </div>
            </div>
            </div>
            </div>
            <p class="mt-2">You may update fare/threshold and try for these trips later.</p>
            `
    return html;
  }
}
